module.exports = __webpack_public_path__ + "img/edge_divers_voiture_electrique.b91aab06.svg";